module.exports = __webpack_public_path__ + "media/images/icons/icon_close_secondary_foss-63c365cda2b54406a3921050a74476a7.svg";